module.exports = [{"title":"Brand","url":"https://primer.style/brand"},{"title":"About","url":"https://primer.style/design/about"}]